module.exports = __webpack_public_path__ + "assets/img/OPENAI.dad1f51e.png";